import { __awaiter, __rest } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useReducer } from 'react';
import { request, LoadingStates } from '@hm-group/frontend-utils/request';
import { ACTIONS } from './helpers/constants';
import requestReducer from './helpers/requestReducer';
/**
 * This hook utilizes @hm-group/frontend-utils request functions.
 * @param {string} url - The api url.
 * @param {object} options - The request option props.
 * @returns {*} - The api response.
 */
const useRequest = (url, options = {}) => {
    const { manual, method = 'get' } = options, restOptions = __rest(options, ["manual", "method"]);
    const [state, dispatch] = useReducer(requestReducer, {
        status: LoadingStates.NotLoaded,
    });
    let didCancel = false;
    const fetchData = (overrideDataToSend) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch({ type: ACTIONS.FETCH_INIT });
        try {
            const { data, status, headers } = yield request[method](url, Object.assign(Object.assign({}, restOptions), (overrideDataToSend && { data: overrideDataToSend })));
            if (!didCancel) {
                dispatch({ type: ACTIONS.FETCH_SUCCESS, payload: { data, statusCode: status, headers } });
            }
        }
        catch (error) {
            if (!didCancel) {
                dispatch({ type: ACTIONS.FETCH_FAILURE, payload: error });
            }
        }
    });
    useEffect(() => {
        if (!manual && !didCancel) {
            fetchData();
        }
        return () => {
            didCancel = true;
        };
    }, [url]);
    return {
        data: state.data,
        loading: state.status === LoadingStates.Loading,
        error: state.error,
        execute: (data) => fetchData(data),
        isRequestMade: state.status !== LoadingStates.NotLoaded,
        statusCode: state.statusCode,
        headers: state.headers,
    };
};
export default useRequest;
//# sourceMappingURL=useRequest.js.map